import api from "./api";

const getAll = () => {
  return api.get("/api/account/get-all");
};

const saveAccount = (account) => {
  return api.post("/api/account/save", account);
};

const updateAccount = (account) => {
  return api.post("/api/account/update", account);
};

const assignCustomersToAccount = (data) => {
  return api.post("/api/account/assign-customers", data);
};

const AccountService = {
  getAll,
  saveAccount,
  updateAccount,
  assignCustomersToAccount,
};

export default AccountService;
